import routerOptions0 from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/app/router.options.ts";
import routerOptions1 from "/Users/naoki.hashimoto/Projects/RetailStudio/Bitbucket/chirashi-viewer/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}